<div class="row">
  <div class="col-sm-1 hidden-xs arrow text-right">
    <a class="di di-previous"
          [ngClass]="{'disabled': shouldDisablePreviousButton()}"
          (click)="goToPreviousSlide()"
          (keyup.enter)="goToPreviousSlide()"
          [attr.tabindex]="!shouldDisablePreviousButton() ? 2 : -1"
          [attr.aria-label]="'link-page.aria-label-previous-slide' | translate">
    </a>
  </div>
  <ng-container *ngFor="let slide of slides; let i = index">
    <div *ngIf="i === currentSlide" class="col-xs-12 col-sm-10 slide">
      <img src="{{slide.src}}"
           alt="{{slide.altText}}"
           (swiperight)="goToPreviousSlide()"
           (swipeleft)="goToNextSlide()"/>
    </div>
  </ng-container>
  <div class="col-sm-1 hidden-xs arrow text-left">
    <a class="di di-next"
          [ngClass]="{'disabled': shouldDisableNextButton()}"
          (click)="goToNextSlide()"
          (keyup.enter)="goToNextSlide()"
          [attr.tabindex]="!shouldDisableNextButton() ? 2 : -1"
          [attr.aria-label]="'link-page.aria-label-next-slide' | translate">
    </a>
  </div>
  <div class="col-sm-offset-1 col-sm-10 hidden-xs nav-desktop">
    <img *ngFor="let slide of slides; let i = index" src="{{slide.src}}" alt="{{slide.altText}}"
         [ngClass]="{'selected': (i === currentSlide)}"
         (click)="goToSlide(i)" />
  </div>
  <div class="visible-xs hidden-sm col-xs-12 text-center nav-mobile">
    <span *ngFor="let dot of slides; let i = index"
          class="dot"
          [ngClass]="{'selected': (i === currentSlide)}"
          (click)="goToSlide(i)"></span>
  </div>
</div>
